<template>
  <div class="box">
    <Tabs
      v-model="currDidTab"
      class="tab_inner"
      name="bb"
      type="line"
      @on-click="change_tab2"
    >
      <TabPane
        v-for="(value, index) in details_data"
        :key="index"
        :label="$t('Changelang.' + value)"
        :name="index.toString()"
      >
        <div>
          <div class="info_box">
            <div>
              <div
                v-if="currDidTab == index.toString() && value === '实时监测'"
                class="content"
              >
                <div class="contentLeft">
                  <div class="contentLeft_top_title">
                    <div>{{ $t("设备ID") }}:</div>
                    <div>BMS SN:</div>
                  </div>
                  <div class="contentLeft_top_value">
                    <div>
                      {{ did }}
                      <span @click="copyToClipboard(did)"
                        ><img src="./images/copy.png" alt="" width="16px"
                      /></span>
                    </div>
                    <div>
                      {{ bms_sn }}
                      <span @click="copyToClipboard(bms_sn)"
                        ><img src="./images/copy.png" alt="" width="16px"
                      /></span>
                    </div>
                  </div>
                  <div class="contentLeft_top_title">
                    <div>PACK SN:</div>
                    <div>{{ $t("固件版本") }}:</div>
                  </div>
                  <div class="contentLeft_top_value">
                    <div>
                      <!-- {{ pack_sn }} -->
                        <span v-if="packSnBl==true"> <Input
    type="text"
    v-model="pack_sn"
    size="small"
 style="width: 75%;margin-right: 5px;"
  /><Button type="success" size="small" @click="handleBlur">保存</Button></span><span v-else>{{ pack_sn }}</span>

                      <span @click="copyToClipboard(pack_sn)"
                        ><img src="./images/copy.png" alt="" width="16px"
                      /></span>
                    </div>
                    <div>
                      {{ hardware_ver }}
                      <span>
                        <Poptip trigger="hover" placement="right-start">
                          <div slot="content" style="margin: 0; padding: 0">
                            <p>
                              {{ $t("通道0") }}: {{ hardware_verAll.chan0 }}
                            </p>
                            <p>{{ $t("通道1") }}:{{ hardware_verAll.chan1 }}</p>
                          </div>
                          <img src="./images/qietu.png" alt="" width="16px" />
                        </Poptip>
                      </span>
                    </div>
                  </div>
                  <div class="echarts_content">
                    <div class="echarts_content_left">
                      <div
                        v-for="(item, index) in items"
                        :key="index"
                        class="item"
                        @click="tiaozhuanGj"
                      >
                        <div v-if="item">
                          <img
                            :src="
                              item.babycolor == 2
                                ? require('./images/lingdang1.png')
                                : require('./images/lingdang.png')
                            "
                            alt="铃铛"
                          />
                        </div>
                        <div
                          v-if="item"
                          :style="{
                            color: item.babycolor == 2 ? 'orange' : 'red',
                          }"
                        >
                          {{ item }}
                        </div>
                        <div v-if="item">
                          <img
                            :src="
                              item.babycolor == 2
                                ? require('./images/tiaozhuan1.png')
                                : require('./images/tiaozhuan.png')
                            "
                            alt="跳转"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="echarts_content_center">
                      <echarsView1 :soc="soc" />
                    </div>
                    <div class="echarts_content_right"></div>
                  </div>
                  <div class="dainchi">
                    <div>
                      <p>{{ $t("设计容量") }}(mAh)</p>
                      <p>{{ sheji_capacity }}</p>
                    </div>
                    <div class="fenkai"></div>
                    <div>
                      <p>{{ $t("剩余容量") }}(mAh)</p>
                      <p>{{ remaining_capacity }}</p>
                    </div>
                    <div class="fenkai"></div>
                    <div>
                      <p>{{ $t("实际容量") }}(mAh)</p>
                      <p>{{ manchong_capacity }}</p>
                    </div>
                  </div>
                  <div class="dianya">
                    <div>
                      <p>
                        <img
                          src="./images/dianya.png"
                          alt=""
                          width="21px"
                        />&nbsp {{ $t("总电压") }}(V)
                      </p>
                      <p>{{ voltage }}</p>
                    </div>
                    <div>
                      <p>
                        <img
                          src="./images/dianya.png"
                          alt=""
                          width="21px"
                        />&nbsp {{ $t("电流") }}(A)
                      </p>
                      <p>{{ current }}</p>
                    </div>
                    <div>
                      <p>
                        <img
                          src="./images/dianya.png"
                          alt=""
                          width="21px"
                        />&nbsp {{ $t("功率") }}(W)
                      </p>
                      <p>{{ Math.abs(gonglv) }}</p>
                    </div>
                  </div>
                  <div class="information">
                    <div class="information_left">
                      <div>
                        <p>{{ $t("充电MOS") }}:</p>
                        <p style="marginleft: 3px">
                          <!-- <Poptip
                            confirm
                            :title="$t('会影响电池包正常是否确认') + '?'"
                            :ok-text="$t('确定')"
                            :cancel-text="$t('取消')"
                            @on-ok="ok1('1')"
                            @on-cancel="cancel"
                          > -->
                          <span
                            :style="{
                              color: chongdianmos == 1 ? 'white' : '#5b6376',
                              border:
                                chongdianmos == 1
                                  ? '1px solid #19be6b'
                                  : '1px solid #eaecee',
                              background:
                                chongdianmos == 1 ? '#19be6b' : '#f7f7f7',
                              padding: '2px 6px',
                              fontSize: '12px',
                              borderRadius: '3px',
                              display: 'inline-block',
                              width: '40px',
                            }"
                          >
                            {{ chongdianmos == 1 ? $t("开启") : $t("关闭") }}
                          </span>
                          <!-- <Tag
                              :color="
                                chongdianmos === 1 ? 'success' : 'default'
                              "
                              :style="{
                                cursor: 'pointer',
                              }"
                              mini
                            >
                              {{ chongdianmos === 1 ? "开启" : "关闭" }}
                            </Tag> -->
                          <!-- </Poptip> -->
                        </p>
                      </div>
                      <div>
                        <p style="margintop: 3px">{{ $t("放电MOS") }}:</p>
                        <p style="marginleft: 3px; margintop: -4px">
                          <!-- <Poptip
                            confirm
                            :title="$t('会影响电池包正常是否确认') + '?'"
                            :ok-text="$t('确定')"
                            :cancel-text="$t('取消')"
                            @on-ok="ok1(2)"
                            @on-cancel="cancel"
                          > -->
                          <span
                            :style="{
                              color: fangdianmos == 1 ? 'white' : '#5b6376',
                              border:
                                fangdianmos == 1
                                  ? '1px solid #19be6b'
                                  : '1px solid #eaecee',
                              background:
                                fangdianmos == 1 ? '#19be6b' : '#f7f7f7',
                              padding: '2px 6px',
                              fontSize: '12px',
                              borderRadius: '3px',
                              height: '22px',
                              display: 'inline-block',
                              width: '40px',
                            }"
                          >
                            {{ fangdianmos == 1 ? $t("开启") : $t("关闭") }}
                          </span>
                          <!-- <Tag
                              :color="
                                fangdianmos === 1 ? 'success' : 'default'
                              "
                              :style="{
                                cursor: 'pointer',
                              }"
                              mini
                            >
                              {{ fangdianmos === 1 ? "开启" : "关闭" }}
                            </Tag> -->
                          <!-- </Poptip> -->
                        </p>
                        <!-- <p> -->
                        <!-- <Tag
                            :color="fangdianmos === 1 ? 'success' : 'default'"
                            mini
                            @click="changeMos('fangdian', fangdianmos)"
                          >
                            {{ fangdianmos === 1 ? "开启" : "关闭" }}
                          </Tag> -->
                        <!-- <span
                            :style="{
                              color: fangdianmos === 1 ? 'green' : '#666',
                              cursor: 'pointer',
                            }"
                            @click="changeMos('fangdian', fangdianmos)"
                          >
                            {{ fangdianmos === 1 ? "开启" : "关闭" }}
                          </span> -->
                        <!-- </p> -->
                      </div>
                      <div style="margintop: 10px">
                        <p>{{ $t("均衡") }}:</p>
                        <!-- <p><Tag color="success">开启</Tag></p> -->
                        <!-- <Tag
                          :color="junheng == '0' ? 'default' : 'success'"
                          mini
                          style="marginleft: 8px"
                          class="junx"
                        >
                          {{ junheng == "0" ? "关闭" : "开启" }}
                        </Tag> -->
                        <span
                          :style="{
                            color: junheng == '0' ? '#666' : 'green',
                          }"
                          style="marginleft: 8px"
                          class="junx"
                        >
                          {{ junheng == "0" ? $t("关闭") : $t("开启") }}
                        </span>
                      </div>

                      <div style="margintop: 10px">
                        <p>{{ $t("MOS温度") }}:</p>
                        <p>{{ mos_wendu / 10 }}℃</p>
                      </div>
                      <!-- <div style="margintop: 9px">
                        <p>{{ $t("环境温度") }}:</p>
                        <p>{{ huanjing_wendu / 10 }}℃</p>
                      </div> -->
                    </div>
                    <div class="information_right">
                      <div>
                        <p>{{ $t("循环次数") }}:</p>
                        <p>{{ xunhuan_num }}</p>
                      </div>
                      <!-- <div>
                        <p>{{ $t("电池串数") }}:</p>
                        <p>{{ dianchichuan }}</p>
                      </div> -->
                      <!-- <div class="container" id="container">
                        <p class="pack">PACK SN:</p>
                        <div class="p">{{ pack_sn }}</div>
                      </div> -->
                      <div>
                        <p>{{ $t("项目号") }}:</p>
                        <p>{{ project_id }}</p>
                      </div>
                      <div>
                        <p>{{ $t("外部软件版本号") }}:</p>
                        <p>{{ bms_version }}</p>
                      </div>
                      <!-- <div>
                        <p>{{ $t("内部软件版本号") }}:</p>
                        <p>{{ inner_ver }}</p>
                      </div>
                      <div>
                        <p>{{ $t("软件开发版本号") }}:</p>
                        <p>{{ soft_ver }}</p>
                      </div> -->
                    </div>
                  </div>
                  <!-- <div class="mapcontent">
                    <div class="map" id="container"></div>
                    <div class="lookmap">
                      <img
                        src="./images/lookmap.png"
                        alt=""
                        @click="tiaozhuanHis"
                      />
                    </div>
                  </div> -->
                </div>
                <div class="contentRight">
                  <div class="contentRight_title">
                    <div class="contentRight_title_from">
                      <!-- <Form
                        ref="formValidate"
                        :model="formValidate"
                        :label-width="80"
                        class="form-container"
                      >
                        <FormItem
                          label="设备数据"
                          prop="city"
                          v-if="chansAll.length > 1"
                        >
                          <Select
                            v-model="formValidate.city"
                            placeholder="请选择"
                            style="width: 138px"
                          >
                            <Option
                              v-for="chans in chansAll"
                              :key="chans"
                              :value="chans"
                            >
                              {{ chans }}
                            </Option>
                          </Select>
                        </FormItem>
                        <FormItem :label="$t('序号')" prop="date">
                          <Input
                            v-model="formValidate.date"
                            placeholder="$t('请输入开始日期')"
                            style="width: 320px"
                          />
                        </FormItem>
                        <div class="youshang">
                          <div>
                            <Button
                              type="primary"
                              class="chax"
                              @click="queryData"
                              >{{ $t("查询") }}</Button
                            >
                          </div>
                        </div>
                      </Form> -->
                      <!-- <div class="findScope">可查询:0-11100,输入格式为0-11100</div> -->
                      <div class="contentRight_title_export">
                        <div class="export-item" @click="exportHistory">
                          <img src="./images/export.png" alt="" />
                          <p>{{ $t("数据导出") }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="echarsView2">
                    <echarsViewSCLI
                      :mosState="mosState"
                      :chongdianmos="chongdianmos"
                      :fangdianmos="fangdianmos"
                      :timestampsLine="timestampsLine"
                      :dianliuLine="dianliuLine"
                      :dianliuLine1="dianliuLine1"
                      :shengyurongliangLine="shengyurongliangLine"
                      :zongdianyaDataLine="zongdianyaDataLine"
                      :chongdianDataLine="chongdianDataLine"
                      :fangdianDataLine="fangdianDataLine"
                      :yachaLine="yachaLine"
                      :moswendu="moswendu"
                      :huanjingwendu="hj_wendu"
                      :NTC4="NTC4"
                      :NTC3="NTC3"
                      :NTC2="NTC2"
                      :NTC1="NTC1"
                      :NTC5="NTC5"
                      :NTC6="NTC6"
                      :NTC7="NTC7"
                      :NTC8="NTC8"
                      :NTC9="NTC9"
                      :NTC10="NTC10"
                      :alarm9_str="alarm9_str"
                      :alarm10_str="alarm10_str"
                      :alarm11_str="alarm11_str"
                      @chartClick="handleChartClick"
                    />
                    <div style="text-align: center; margin-bottom: 10px">
                      <Page
                        :total="total"
                        size="small"
                        show-total
                        :page-size="pageSize"
                        @on-change="handlePageChange"
                        :current="currentPage"
                      />
                    </div>
                  </div>
                  <div class="contentRight_footer">
                    <div style="background: white">
                      <div class="contentRight_footer_title">
                        {{ $t("单体电池视图") }}
                      </div>
                      <div class="contentRight_footer_content">
                        <div class="contentRight_footer_left">
                          <div>
                            <p>{{ $t("最高电压") }}</p>
                            <p style="color: rgba(255, 125, 0, 1)">
                              {{ highestRight }}V
                            </p>
                          </div>
                          <div>
                            <p>{{ $t("最低电压") }}</p>
                            <p style="color: rgba(14, 197, 192, 1)">
                              {{ minimumRight }}V
                            </p>
                          </div>
                          <div>
                            <p>{{ $t("压差") }}</p>
                            <p>{{ yachaRight }}mV</p>
                          </div>
                          <div>
                            <p>{{ $t("平均电压") }}</p>
                            <p>{{ averageRight }}V</p>
                          </div>
                        </div>
                        <div class="contentRight_footer_right">
                          <div class="contentRight_footer_right_top">
                            <div v-for="(value, index) in values" :key="index">
                              <div
                                class="dianchi"
                                :style="getDianchiStyle(value)"
                              >
                                {{ index + 1 }}
                              </div>
                              <p class="dianchivalue">
                                {{ $t("电压") }}:{{ value }}V
                              </p>
                            </div>
                          </div>
                          <div class="contentRight_footer_right_btn">
                            <echarsView3 :values="values" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else-if="
                  currDidTab == index.toString() && value === '历史记录'
                "
              >
                <DistributionLog :hasDid="1"></DistributionLog>
              </div>
            </div>
          </div>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import packageTableMixins from "@/mixins/packageTableMixins";
import refreshCustom from "./components/refreshCustom";
import moreCustom from "./components/moreCustom";
import logoImg1 from "./images/dianchi1.png";
import logoImg2 from "./images/dianchi2.png";
import logoImg3 from "./images/dianchi3.png";
import DistributionLog from "../devicedistribution/distributionLogSCLI";
import Control from "../control/control.vue";
import Historyrouter from "../historyrouter/historyrouter";
import echarsView1 from "./echarsView1.vue";
import echarsViewSCLI from "./echarsViewSCLI.vue";
import echarsView3 from "./echarsView3.vue";
import axios from "axios";
import AlermDes from "../../alarmManage/alermDes/alermDes2.vue";
import { ChartPie, ChartItemBar, ChartLineStackMul2 } from "_c/charts";
import {
  get_device4g,
  get_left_data4g,
  get_qr_code,
  get_4g_broken_line,
  get_danti_view,
  get_qgl_data,
  get_qgl_broken_line,
  editPackSn,
  dldpset
} from "@/api/chuku";
import {
  get_now_lnglat,
  get_downloadtoken,
  config_caiyang_pinglv,
  iotconfigset,
  web_issue_order,
  upup_firmware,
  progress_firmware,
  did_config_pass,
  get_firmware_info
} from "@/api/jingxiaoshang";
import { commonReq } from "@/api/common";
import * as echarts from "echarts";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data() {
    const now = new Date();
    const startOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0
    );
    const endOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59
    );

    return {
      packSnBl: false,
      currentPage: 1,
      pageSize: 35,
      is_dingji: localStorage.getItem("is_dingji"),
      progress_text: "",
      password: null,
      passwordTypeIcon: "ios-eye",
      passwordType: "password",
      firmware_list: [],
      booleanValue: null,
      interval: null,
      mosState: null,
      shuaxin: null,
      timeoutId: null,
      NTC1: null,
      NTC2: null,
      NTC3: null,
      NTC4: null,
      NTC5: null,
      NTC6: null,
      NTC7: null,
      NTC8: null,
      NTC9: null,
      NTC10: null,
      alarm9_str: null,
      alarm10_str: null,
      alarm11_str: null,
      hj_wendu: null,
      moswendu: null,
      voltage_listRight: null,
      highestRight: null,
      minimumRight: null,
      yachaRight: null,
      averageRight: null,
      timestampsLine: null,
      dianliuLine: null,
      dianliuLine1: null,
      shengyurongliangLine: null,
      yachaLine: null,
      zongdianyaDataLine: null,
      fangdianDataLine: null,
      chongdianDataLine: null,
      intervalId: null,
      project_id: null,
      pack_sn: null,
      xunhuan_num: null,
      dianchichuan: null,
      mos_wendu: null,
      now_connect_status: null,
      huanjing_wendu: null,
      chongdianmos: null,
      junheng: null,
      fangdianmos: null,
      now_connect_status: null,
      voltage: null,
      current: null,
      gonglv: null,
      manchong_capacity: null,
      remaining_capacity: null,
      sheji_capacity: null,
      battery_status: null,
      soc: null,
      total: null,
      rightAllData: null,
      hardware_verAll: { chan0: null, chan1: null },
      hardware_ver: null,
      pack_sn: null,
      chans: null,
      chansAll: null,
      did: this.$route.query.did,
      bms_sn: null,
      bms_version: null,
      inner_ver: null,
      soft_ver: null,
      values: [], // 示例数据
      formValidate: {
        city: "",
        date: [startOfDay, endOfDay]
      },
      gaugeChart: null,
      currDidTab: "0",
      map: null,
      details_data: ["实时监测", "历史记录"],
      items: [],
      imgSrc: require("./images/fengwo.png"), // 初始图片源
      isClickable: true // 控制是否可以点击
    };
  },
  components: {
    ChartPie,
    ChartItemBar,
    ChartLineStackMul2,
    DistributionLog,
    AlermDes,
    Control,
    Historyrouter,
    echarsView1,
    echarsViewSCLI,
    echarsView3
  },
  methods: {
    ok1(val) {},
    cancel() {},

    change_tab2(tab) {
      this.currDidTab = tab;
      if (this.$route.query.tabs) {
        this.$router.push({
          path: this.$route.path, // 保留当前路径
          query: {
            ...this.$route.query, // 保留其他查询参数
            tabs: tab // 更新 tabs 参数
          }
        });
      }

      this.check_new();
    },
    //背景
    getDianchiStyle(value) {
      const maxValue = Math.max(...this.values);
      const minValue = Math.min(...this.values);

      if (value == maxValue) {
        return {
          backgroundImage: `url(${logoImg3})` // 最大值背景
        };
      } else if (value == minValue) {
        return {
          backgroundImage: `url(${logoImg2})` // 最小值背景
        };
      } else {
        return {
          backgroundImage: `url(${logoImg1})` // 其他值背景
        };
      }
    },
    //折线图
    convertLine(value) {
      // this.mosState=value.
      this.timestampsLine = value.map(item => item.xuhao);
      this.dianliuLine = value.map(item => {
        const dianliuValue = Number(item.current);
        return dianliuValue < 0 ? 0 : dianliuValue;
      });
      this.dianliuLine1 = value.map(item => {
        const dianliuValue = Number(item.current);
        return dianliuValue > 0 ? 0 : Math.abs(dianliuValue);
      });
      this.shengyurongliangLine = value.map(item => {
        return Math.round(
          (item.remaining_capacity / item.manchong_capacity) * 100
        );
      });

      this.yachaLine = value.map(item => {
        const voltageList = item.voltage_list;
        const maxVoltage = Math.max(...voltageList);
        const minVoltage = Math.min(...voltageList);
        return maxVoltage - minVoltage;
      });
      this.zongdianyaDataLine = value.map(item =>
        Number(item.voltage).toFixed(2)
      );
      this.chongdianDataLine = value.map(item => Number(item.chongdianmos));
      this.fangdianDataLine = value.map(item => Number(item.fangdianmos));
      this.moswendu = value.map(item => Number(item.mos_wendu / 10));
      this.hj_wendu = value.map(item => Number(item.hj_wendu / 10));
      this.NTC1 = value.map(item => Number(item.wendu_list[0] / 10));
      this.NTC2 = value.map(item => Number(item.wendu_list[1] / 10));
      this.NTC3 = value.map(item => Number(item.wendu_list[2] / 10));
      this.NTC4 = value.map(item => Number(item.wendu_list[3] / 10));
      this.NTC5 = value.map(item => Number(item.wendu_list[4] / 10));
      this.NTC6 = value.map(item => Number(item.wendu_list[5] / 10));
      this.NTC7 = value.map(item => Number(item.wendu_list[6] / 10));
      this.NTC8 = value.map(item => Number(item.wendu_list[7] / 10));
      this.NTC9 = value.map(item => Number(item.wendu_list[8] / 10));
      this.NTC10 = value.map(item => Number(item.wendu_list[9] / 10));
      this.alarm9_str = value.map(item => item.alarm9_str);
      this.alarm10_str = value.map(item => item.alarm10_str);
      this.alarm11_str = value.map(item => item.alarm11_str);
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    //查询
    queryData() {
      this.formValidate.date[0] = this.formatDate(this.formValidate.date[0]);
      this.formValidate.date[1] = this.formatDate(this.formValidate.date[1]);
      get_4g_broken_line({
        did: this.did,
        chan: this.formValidate.city,
        start_time: this.formValidate.date[0],
        end_time: this.formValidate.date[1]
      }).then(res => {
        this.mosState = res.body.mos;
        this.convertLine(res.body.yunxing_trends);
      });
      this.echartsZhu();
    },
    echartsZhu() {
      get_danti_view({ did: this.did, chan: this.formValidate.city }).then(
        res => {
          this.values = res.body.voltage_list;
          this.highestRight = res.body.highest;
          this.minimumRight = res.body.minimum;
          this.yachaRight = res.body.yacha;
          this.averageRight = res.body.average.toFixed(3);
        }
      );
    },
    //复制信息
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$Message.success(this.$t("复制成功"));
        })
        .catch(err => {
          this.$Message.warning("复制失败");
        });
    },
    //导出
    exportHistory() {
      // this.formValidate.date[0] =
      //   new Date(this.formValidate.date[0]).getTime() / 1000;
      // this.formValidate.date[1] =
      //   new Date(this.formValidate.date[1]).getTime() / 1000;
      // get_downloadtoken({ type: "1" }).then((res) => {
      //   if (res.result === 0) {
      //     let downloadtoken = res.body.downloadtoken;
      //     let country_code = localStorage.getItem("country_code");
      //     const baseUrl =
      //       country_code === "xciot-prod-cnsz"
      //         ? "https://bms-api.xcthings.com"
      //         : country_code === "xciot-prod-hk"
      //         ? "https://bms-hk-api.xcthings.com"
      //         : country_code === "xciot-prod-us2"
      //         ? "https://bms-us-api.xcthings.com"
      //         : "https://bms-eu-api.xcthings.com";
      //     axios
      //       .post(`https://bms-api.xcthings.com/index.php/admin/devicedetail/get_device_type`, {
      //         did: this.did,
      //       })
      //       .then((response) => {
      //         if (response.data.result === 0) {
      //           let lang =
      //             localStorage.getItem("local") === "en-US" ? "en-us" : "zh-cn";
      //           axios
      //             .post(
      //               `https://bms-api.xcthings.com/index.php/admin/device/history_daochu?lang=${lang}`,
      //               {
      //                 type: 1,
      //                 downloadtoken: downloadtoken,
      //                 did: this.did,
      //                 time_start: this.formValidate.date[0],
      //                 time_end: this.formValidate.date[1],
      //                 page: this.currentPage,
      //               }
      //             )
      //             .then((res) => {
      //               if (res.data.result !== 0) {
      //                 this.$Message.error(res.errorMsg);
      //               }
      //             });
      //           this.$Message.success(this.$t("导出成功"));
      //           this.$Modal.remove();
      //           const routeData = this.$router.push({
      //             path: "/deviceman/downloadlist",
      //           });
      //           window.open(routeData.href, "_self");
      //         }
      //       });
      //   } else {
      //     this.$Message.error(res.errorMsg);
      //   }
      // });
      this.$router.push({
        path: "/deviceman/distributionLog",
        query: { did: this.$route.query.did }
      });
    },
    tiaozhuanGj() {
      this.currDidTab = "4";
    },
    refresh() {
      let vm = this;
      let config = {
        loading: true,
        width: 500,
        render: h => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  // "刷新频率"
                  vm.$t("刷新频率")
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer"
                  },
                  on: {
                    click: evt => {
                      vm.$Modal.remove();
                    }
                  }
                })
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0"
              }
            }),
            h(refreshCustom, {
              ref: "refreshCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: false,
                shuaxin: localStorage.getItem("shuaxin") || 60,
                parent_code: "0",
                parent_name: "无"
              }
            })
          ]);
        },
        onOk: function() {
          let _this = this;
          let obj = this.$refs.refreshCustom;
          obj.checkForm().then(res => {
            if (res) {
              vm.shuaxin = obj.formModel.refresh_value;
              vm.$Message.success("设置成功");
              vm.$Modal.remove();
              clearInterval(vm.dingshi);
              vm.dingshi = setInterval(vm.iotdatalastget, vm.shuaxin * 1000);
              localStorage.setItem("shuaxin", vm.shuaxin);
              //     vm.init()
            }
          });
          // let _this = this;
          // let obj = this.$refs.refreshCustom;
          // obj.checkForm().then(res => {
          // if (res) {
          //   area_add({...obj.formModel}).then(res => {
          //   let msg=res.errorMsg;
          //   if (res.result === 0) {
          //     let msg=res.errorMsg;
          //     vm.$Message.success(msg);
          //     vm.$Modal.remove();
          //     vm.init()
          //   } else {
          //   vm.$Message.error(msg);
          //     _this.buttonLoading = false;
          //   }
          // });
          // } else {
          //     _this.buttonLoading = false;
          // }
          //  });
        }
      };
      this.$Modal.confirm(config);
    },
    //告警映射
    Alarms9Text(alarmString) {
      // 每个位置对应的告警描述
      const alarms = [
        "低电量告警",
        "MOS高温告警",
        "环境低温告警",
        "环境高温告警",
        "放电低温告警",
        "充电低温告警",
        "放电高温告警",
        "充电高温告警",
        "预留",
        "电芯故障告警",
        "放电过流告警",
        "充电过流告警",
        "总压低压告警",
        "总压过压告警",
        "单体低压告警",
        "单体过压告警"
      ];

      alarmString.split("").forEach((bit, index) => {
        if (bit === "1") {
          this.items.push(alarms[index]);
        }
      });
    },
    Alarms10Text(alarmString) {
      // 每个位置对应的告警描述
      const alarms = [
        "Fully（充满）",
        "环境低温保护",
        "环境高温保护",
        "MOS高温保护",
        "放电低温保护（电芯）",
        "充电低温保护（电芯）",
        "放电高温保护（电芯）",
        "充电高温保护（电芯）",
        "充电器高压",
        "短路",
        "放电过流保护",
        "充电过流保护",
        "总压过放保护",
        "总压过压保护",
        "单体过放保护",
        "单体过压保护"
      ];

      alarmString.split("").forEach((bit, index) => {
        if (bit === "1") {
          this.items.push(alarms[index]);
        }
      });
    },
    Alarms11Text(alarmString) {
      // 每个位置对应的告警描述
      const alarms = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "加热膜故障",
        "限流故障",
        "放电过采样芯片故障流保护",
        "电芯故障",
        "",
        "温度传感器故障",
        "放电MOS故障",
        "充电MOS故障"
      ];

      alarmString.split("").forEach((bit, index) => {
        if (bit === "1") {
          this.items.push(alarms[index]);
        }
      });
    },
    //实时数据
    getleftData() {
      get_qgl_data({ did: this.did, sdid: "SCLI" }).then(res => {
        this.bms_sn = res.body.bms_sn;
        this.pack_sn = res.body.pack_sn;
        this.hardware_verAll = res.body.hardware_ver;
        if (res.body.hardware_ver.chan1) {
          this.hardware_ver = res.body.hardware_ver.chan1;
        } else {
          this.hardware_ver = res.body.hardware_ver.chan0;
        }
        // this.items = res.body.data_protected_list.slice(0, 7);
        this.soc = res.body.soc;
        this.battery_status = res.body.battery_status;
        this.remaining_capacity = res.body.remaining_capacity;
        this.sheji_capacity = res.body.sheji_capacity;
        this.manchong_capacity = res.body.manchong_capacity;
        this.voltage = Number(res.body.voltage).toFixed(2);
        this.current = Number(res.body.current).toFixed(2);
        this.gonglv = Number(res.body.voltage * res.body.current).toFixed(2);
        this.now_connect_status = res.body.now_connect_status;

        this.junheng = res.body.junheng;
        this.dianchichuan = res.body.dianchichuan;
        this.mos_wendu = res.body.mos_wendu;
        this.huanjing_wendu = res.body.hj_wendu;
        this.xunhuan_num = res.body.xunhuan_num;
        this.pack_sn = res.body.pack_sn;
        this.project_id = res.body.project_id;
        this.bms_version = res.body.bms_version;
        this.inner_ver = res.body.inner_ver;
        this.soft_ver = res.body.soft_ver;
        this.Alarms9Text(res.body.alarm9_str);
        this.Alarms10Text(res.body.alarm10_str);
        this.Alarms11Text(res.body.alarm11_str);
        this.chongdianmos = res.body.alarm11_str[5];
        this.fangdianmos = res.body.alarm11_str[4];
        this.values = res.body.voltage_list.map(value => value / 1000);
        this.highestRight = Math.max(...res.body.voltage_list) / 1000;
        this.minimumRight = Math.min(...res.body.voltage_list) / 1000;
        this.yachaRight = Math.round(
          (this.highestRight - this.minimumRight) * 1000
        );
        this.averageRight = (
          res.body.voltage_list.reduce((sum, value) => sum + value, 0) /
          res.body.voltage_list.length /
          1000
        ).toFixed(3);
      });
    },
    //获取历史
    getrightData(val) {
      get_qgl_broken_line({
        did: this.did,
        sdid: "SCLI",
        page: val
      }).then(res => {
        this.rightAllData = res.body.list;
        this.total = res.body.total;
        this.convertLine(res.body.list);
      });
    },
    handlePageChange(pageSize) {
      this.currentPage = pageSize;
      this.getrightData(pageSize);
    },
    handleChartClick(data) {
      const foundItem = this.rightAllData.find(
        item => item.xuhao === Number(data.data)
      );
      this.values = foundItem.voltage_list.map(value => value / 1000);
      this.highestRight = Math.max(...foundItem.voltage_list) / 1000;
      this.minimumRight = Math.min(...foundItem.voltage_list) / 1000;
      this.yachaRight = Math.round(
        (this.highestRight - this.minimumRight) * 1000
      );
      this.averageRight = (
        foundItem.voltage_list.reduce((sum, value) => sum + value, 0) /
        foundItem.voltage_list.length /
        1000
      ).toFixed(3);
    },
    web_shuaxin() {
      this.did = this.$route.query.did;
      if (this.$route.query.tabs) {
        this.currDidTab = this.$route.query.tabs;
      }
      // get_device4g({ did: this.did }).then((res) => {
      //   this.chansAll = res.body.chans;
      //   this.chans = res.body.chans[0];
      //   this.formValidate.city = res.body.chans[0];
      // get_left_data4g({ did: this.did, chan: this.chans, web_time: 0 }).then(
      //   (res) => {
      //     this.sn = res.body.sn;
      //     this.pack_sn = res.body.pack_sn;
      //     this.hardware_verAll = res.body.hardware_ver;
      //     if (res.body.hardware_ver.chan1) {
      //       this.hardware_ver = res.body.hardware_ver.chan1;
      //     } else {
      //       this.hardware_ver = res.body.hardware_ver.chan0;
      //     }
      //     this.items = res.body.data_protected_list.slice(0, 7);
      //     console.log("左侧数据", this.items);
      //     this.soc = res.body.soc;
      //     this.battery_status = res.body.battery_status;
      //     this.remaining_capacity = res.body.remaining_capacity;
      //     this.manchong_capacity = res.body.manchong_capacity;
      //     this.zongdianya = res.body.zongdianya;
      //     this.dianliu = res.body.dianliu;
      //     this.gonglv = res.body.gonglv;
      //     this.now_connect_status = res.body.now_connect_status;
      //     this.chongdianmos = res.body.chongdianmos;
      //     this.fangdianmos = res.body.fangdianmos;
      //     this.junheng = res.body.junheng;
      //     this.dianchichuan = res.body.dianchichuan;
      //     this.mos_wendu = res.body.mos_wendu;
      //     this.huanjing_wendu = res.body.huanjing_wendu;
      //     this.xunhuan_num = res.body.xunhuan_num;
      //     this.pack_sn = res.body.pack_sn;
      //     this.project_id = res.body.project_id;
      //     this.out_ver = res.body.out_ver;
      //     this.inner_ver = res.body.inner_ver;
      //     this.soft_ver = res.body.soft_ver;
      //   }
      // );

      // get_danti_view({ did: this.did, chan: this.chans }).then((res) => {
      //   this.values = res.body.voltage_list;
      //   this.highestRight = res.body.highest;
      //   this.minimumRight = res.body.minimum;
      //   this.yachaRight = res.body.yacha;
      //   this.averageRight = res.body.average;
      // });
      // console.log(
      //   "this.formValidate.date[0]",
      //   this.formatDate(this.formValidate.date[0])
      // );

      // get_4g_broken_line({
      //   did: this.did,
      //   chan: this.formValidate.city,
      //   start_time: this.formatDate(this.formValidate.date[0]),
      //   end_time: this.formatDate(this.formValidate.date[1]),
      // }).then((res) => {
      //   this.mosState = res.body.mos;
      //   this.convertLine(res.body.yunxing_trends);
      // });
      // });

      this.getleftData();
      this.getrightData(1);
    },
    // startTimer() {
    //   this.shuaxin = localStorage.getItem("shuaxin") || 60;
    //   let shuaxintime = this.shuaxin * 1000;
    //   this.clearTimer();
    //   this.timeoutId = setInterval(() => {
    //     this.web_shuaxin();
    //   }, shuaxintime);
    // },

    clearTimer() {
      if (this.timeoutId) {
        clearInterval(this.timeoutId);
        this.timeoutId = null;
      }
    },
    savepassword() {
      did_config_pass({ pass: this.password, did: this.did }).then(res => {
        let msg = res.errorMsg;
        if (res.result === 0) {
          this.$Message.success(msg);
        } else {
          this.$Message.error(msg);
        }
      });
    },
    swicthPassword() {
      if (this.passwordTypeIcon === "ios-eye") {
        this.passwordTypeIcon = "ios-eye-off";
        this.passwordType = "text";
      } else if (this.passwordTypeIcon === "ios-eye-off") {
        this.passwordTypeIcon = "ios-eye";
        this.passwordType = "password";
      }
    },
    uploadFirmware(dp_chan) {
      let did = this.did;
      this.result_firmware = [];
      let vm = this;
      let config = {
        title: "升级",
        loading: true,
        content: "您确定要升级通道" + dp_chan + "的固件吗？",
        onOk: function() {
          let _this = this;
          upup_firmware({ did: did, dp_chan: dp_chan }).then(res => {
            if (res.result === 0) {
              _this.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              _this.buttonLoading = false;
              // this.getFirmwareInfo()
              //拉取进度
              vm.firmware_list[dp_chan].is_jindu = 1;
              vm.firmware_list[dp_chan].is_shengji = 0;
              // vm.progress_dingshi = setInterval(vm.progress, 5000);
              vm.progress_dingshi = setInterval(function() {
                vm.progress(dp_chan);
              }, 3000);
            } else {
              _this.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //检测新的固件版本
    check_new(chan_id) {
      //alert(123)
      //get_firmware_info
      // console.log("aaa",this.did)
      //获取设备信息
      get_firmware_info({ did: this.did }).then(res => {
        this.tableLoading = false;
        this.tableDataList = [];
        if (res.result === 0) {
          //this.details_data = res.body;
          // if (res.body.firmware == "") {
          //   this.$Message.error("暂无可更新固件");
          // }
          if (res.body.firmware && res.body.firmware.length > 0) {
            //this.is_update=res.body.firmware[0].is_update
            if (this.is_update === 0) {
              //  this.$Message.info("已经是最新版本")
            } else {
              //  this.$Message.success("检测出可升级的固件")
            }
            //console.log("res.body.firmware.firmware_ver.multi_rom",res.body.firmware.firmware_ver.multi_rom)

            this.firmware_list = res.body.firmware;
            if (chan_id == 0 || chan_id > 0) {
              this.$Message.success(this.$t("检测成功"));
            }
          } else {
            this.is_update = 0;
            //  this.$Message.error("暂无可升级的固件")
          }
        } else {
          this.tableDataList = [];
          this.getPageTotal = 0;
          this.$Message.error(res.errorMsg);
        }
      });
    },
    progress(dp_chan) {
      let did = this.did;
      progress_firmware({ did: did, dp_chan: dp_chan }).then(res => {
        if (res.result === 0) {
          if (res.body.jindu == 100) {
            setTimeout(() => {
              this.check_new();
            }, 15000); // 15000 毫秒 = 15 秒
          }
          // //拉取进度
          //this.is_jindu = 1;
          this.firmware_list[dp_chan].is_jindu = 1;
          if (res.body.jindu == 100) {
            clearInterval(this.progress_dingshi);
          }

          this.firmware_list[dp_chan].progress_percent = res.body.jindu;
          this.firmware_list[dp_chan].progress_text = res.body.ext_code;

          if (this.result_firmware.length >= 6) {
            let last = this.result_firmware.length - 1;
            if (
              this.result_firmware[last] == this.result_firmware[last - 1] &&
              this.result_firmware[last] == this.result_firmware[last - 2] &&
              this.result_firmware[last] == this.result_firmware[last - 3] &&
              this.result_firmware[last] == this.result_firmware[last - 4] &&
              this.result_firmware[last] == this.result_firmware[last - 5] &&
              this.result_firmware[last] == this.result_firmware[last - 6]
            ) {
              clearInterval(this.progress_dingshi);
              //this.$Message.error("固件升级超时，升级失败")
              this.$Notice.open({
                title: "升级通知",
                desc: "通道" + dp_chan + "固件升级超时，升级失败",
                duration: 0
              });
              this.check_new();
            }
          }
          this.result_firmware.push(res.body.jindu);
        } else {
          this.$Message.error(res.errorMsg);
          //this.is_jindu = 0;
          this.firmware_list[dp_chan].is_jindu = 0;
          //this.is_shengji = 1
          this.firmware_list[dp_chan].is_shengji = 1;
          //this.progress_percent = 0;
          this.firmware_list[dp_chan].progress_percent = 0;
          //this.progress_text = "";
          this.firmware_list[dp_chan].progress_text = "";
          clearInterval(this.progress_dingshi);
        }
        //这里
        // if (this.progress_percent < 100) {
        //   this.progress_percent += 10;
        // }
      });
    },
    handleBlur() {
 let dpcmd = {
            dpcmd: {
              t: 0,
              did: this.did,
              sdid: "",
              seq: 1,
              timestamp: parseInt(new Date().getTime() / 1000),
              ans: false,
              dpv_count: 1,
              dps: [
                {
                  dp_id: 2318,
                  dp_type: 2,
                  dp_chan: 0,
                  val_str:this.pack_sn
                }
              ]
            }
          };
             dldpset(dpcmd).then(res => {
            if (res.result == 0) {
              this.$Message.success(this.$t("修改成功"));
            } else {
              this.$Message.error("修改失败");
            }
          });
    }
  },
  mounted() {
    this.web_shuaxin();
    // this.startTimer();
    // this.initializeTimer();
    this.intervalId = setInterval(() => {
      this.items = [];
      this.getleftData();
    }, 6000);
    editPackSn({ did: this.$route.query.did, dpid: 2318 }).then(res => {
      console.log("是否支持", res);
      if (res.body.is_support == 1) {
        this.packSnBl = true;
      } else {
        this.packSnBl = false;
      }
    });
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.intervalId);
  },
  destroyed() {}
};
</script>
<style scoped>
.box {
  position: relative;
  overflow: auto;
  min-width: 1700px;
}
.content {
  display: flex;
}
.contentLeft {
  width: 520px;
  margin-right: 12px;
  background: white;
  padding: 20px;
}
.contentLeft_top_title {
  display: flex;
}
.contentLeft_top_title div {
  width: 50%;
  color: rgba(105, 109, 115, 1);
  font-size: 14px;
  font-weight: 400;
}
.contentLeft_top_value {
  display: flex;
  color: rgba(53, 55, 57, 1);
  font-size: 14px;
  font-weight: 600;
}
.contentLeft_top_value div:nth-child(1) {
  width: 53%;
  flex-wrap: nowrap;
}
.contentLeft_top_value div span {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}
.contentLeft_top_title div:nth-child(2) {
  margin-left: 30px;
}
.contentLeft_top_title {
  margin-top: 10px;
}
.echarts_content {
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
}
.echarts_content_left {
  line-height: 50%;
  font-size: 14px;
  width: 150px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 省略号 */
}
.item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}
.echarts_content_left div img {
  width: 16px;
}
.echarts_content_left div:nth-child(1) {
  margin-right: 5px;
}
.echarts_content_center {
  margin-left: -140px;
}
.dainchi {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.dainchi div {
  margin-right: 30px;
}
.dainchi div p {
  text-align: center;
}
.dainchi div p:nth-child(2) {
  color: rgba(53, 55, 57, 1);
  font-weight: 600;
}
.dianchibj {
  /* background: rgba(242, 243, 246, 1); */
  /* border-radius: 6px;
  padding: 2px; */
  /* margin: auto; */
}
.fenkai {
  height: 30px;
  margin-top: 5px;
  border-right: 1px solid rgba(216, 216, 216, 1);
}
.dianya {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  width: 480px;
  margin-right: auto;
  border: 1px solid rgba(225, 230, 234, 1);
  border-radius: 6px;
  padding: 10px 0;
}
.dianya div p {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dianya div p:nth-child(2) {
  color: rgba(53, 55, 57, 1);
  font-weight: 700;
  font-size: 16px;
}
.information {
  display: flex;
  margin-top: 20px;
}
.information_left {
  width: 180px;
  border-right: 1px solid rgba(216, 216, 216, 1);
}
.information_left div {
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.information_left div p:nth-child(2) {
  margin-left: 10px;
}
.information_left div p:nth-child(1) {
  width: 100px;
}
.progress_text {
  font-weight: bold;
}
.information_right {
  margin-left: 20px;
  font-size: 14px;
}

.information_right div p:nth-child(1) {
  width: 110px;
}

/* .container {
  width: 100%;
}
#container {
  width: 100%;
  margin-top: 5px;
}
.p {
  word-break: break-all;
  margin-left: 15px;
}
.pack {
  margin-top: -10px;
} */
/* .information_right div p:nth-child(2) {
  width: 80px;
 flex-wrap: wrap;
} */
.information_right div {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
/* .information_right div:nth-child(5) {
  margin-top: 8px;
}
.information_right div:nth-child(6) {
  margin-top: 6px;
}
.information_right div:nth-child(7) {
  margin-top: 6px;
} */
.mapcontent {
  position: relative;
}
.map {
  width: 478px;
  height: 403px;
  margin: auto;
  margin-top: 20px;
}
.lookmap img {
  width: 88px;
  height: 26px;
  position: absolute;
  right: 5px;
  top: 5px;
}
.contentRight {
  width: calc(100% - 520px);
  min-width: 1000px;
  background: white;
}
.echarsView2 {
  width: 100%;
}
.box2 {
  padding: 0 20px;
}
.contentRight_footer_right_btn {
  width: 100%;
  padding-right: 150px;
}
.contentRight_title {
  position: relative;
  padding-top: 12px;
}
.contentRight_title_from {
  position: relative;
}
.contentRight_title_export {
  display: flex;
  align-items: center;
  justify-content: end;
  position: absolute;
  right: 5px;
  top: 0px;
}
.contentRight_title_export p {
  color: rgba(45, 140, 240, 1);
  font-size: 16px;
}
.contentRight_title_export {
  display: flex;
  flex-direction: row;
}
.form-container {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  align-items: center; /* 垂直居中对齐 */
  gap: 10px; /* 元素间距 */
}
.export-item {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  margin-right: 10px; /* 每项之间的间距 */
  cursor: pointer;
  z-index: 999;
}

.export-item img {
  margin-right: 4px; /* 图片与文字之间的间距 */
  width: 16px;
}
.contentRight_footer_content {
  display: flex;
}
.contentRight_footer {
  background: rgba(242, 243, 246, 1);
  padding-top: 12px;
  padding-bottom: 12px;
}
.contentRight_footer_left {
  width: 150px;
}
.contentRight_footer_left div {
  margin-top: 20px;
  margin-left: 16px;
  background: white;
}
.contentRight_footer_left div p:nth-child(1) {
  font-size: 14px;
  color: rgba(105, 109, 115, 1);
}
.contentRight_footer_left div p:nth-child(2) {
  font-size: 16px;
  font-weight: 700;
  color: rgba(53, 55, 57, 1);
}

.contentRight_footer_title {
  padding: 12px;
  color: rgba(53, 55, 57, 1);
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid rgba(225, 230, 234, 1);
}
.dianchi {
  width: 90px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  background-size: cover; /* 使背景图像覆盖整个 div */
  background-position: center; /* 居中显示背景图像 */
}
.dianchivalue {
  width: 90px;
  text-align: center;
}
.contentRight_footer_right {
  margin-left: 5px;
  width: 80%;
}
.contentRight_footer_right_top {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  height: 200px;
  overflow-y: auto;
}

.contentRight_footer_right_top div {
  flex: 0 0 90px; /* 每个元素固定宽度为 90px */
  margin-right: calc((100% - 90px * 8) / 7); /* 计算元素间距，最多 8 个元素 */
  margin-top: 5px;
}

.contentRight_footer_right_top div:nth-child(8n) {
  margin-right: 0; /* 每行最后一个元素不需要右边距 */
}
.youshang {
  display: flex;
  align-items: center;
  margin-top: -22px;
}
.chax {
  margin-right: 10px;
}
.junx {
  margin-left: 8px;
}
.box_title {
  position: absolute;
  right: 5px;
  top: 10px;
  display: flex;
  align-items: center;
  z-index: 1;
}
.box_title span {
  color: rgba(45, 140, 240, 1);
}
.box_title img {
  margin: 0 8px;
}

.piliang,
.piliang2 {
  margin-right: 10px;
  cursor: pointer;
}
.findScope {
  margin: -20px 0 0 80px;
}
</style>
